import { render, staticRenderFns } from "./MenuItemTextOnly.vue?vue&type=template&id=a0e046e2&scoped=true"
import script from "./MenuItemTextOnly.vue?vue&type=script&lang=ts"
export * from "./MenuItemTextOnly.vue?vue&type=script&lang=ts"
import style0 from "./MenuItemTextOnly.vue?vue&type=style&index=0&id=a0e046e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e046e2",
  null
  
)

export default component.exports